import * as z from 'zod';
export const FormValidationErrorSchema = z.object({
    data: z.object({
        fieldErrors: z.record(z.string()).optional(),
        formError: z.any().optional(),
        formErrors: z.array(z.any()).optional(),
    }),
    status: z.literal(422),
});
export const ProblemDetailsSchema = z.object({
    data: z.object({
        message: z.string().optional(),
        translationKey: z.string().optional(),
    }),
    status: z.number().optional(),
});
export const StatusSchema = z.object({
    status: z.number().optional(),
});
export const MessageSchema = z.object({
    data: z.object({
        message: z.string(),
    }),
    status: z.number().optional(),
});
export const ErrorSchema = z.object({
    message: z.string(),
});
export const RequestResponseSchema = z.object({
    request: z.object({
        response: z.string(),
    }),
});
export const PathSchema = z.object({
    data: z.object({
        path: z.string(),
    }),
    status: z.number().optional(),
});
export const MessageSchemaWithTranslationOptions = MessageSchema.extend({
    data: z.object({
        message: z.string(),
        translationOptions: z.custom().optional(),
    }),
});
